import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import EmployeeCheckIn from '../components/home/checkin/CheckIn';
import NavUserButton from '../components/others/NavUserButton';
import Clock from './Clock';
import Modal from './Modal';
import './NavBar.scss';

function NavBar({ isSidebarOpen, setIsSidebarOpen }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const navigate = useNavigate(); // Initialize the navigate function
  const location = useLocation(); // Get the current page location

  // Split the current path and remove empty segments (if any)
  const pathSegments = location.pathname.split('/').filter(Boolean);
  return (
    <div className="navbar flex justify-between items-center p-4">
      <div className="flex items-center">
        <span className="openLeftSidebar cursor-pointer mr-4" onClick={toggleSidebar}>
          {isSidebarOpen ? (
            <CloseOutlinedIcon className="h-6 w-6" />
          ) : (
            <MenuOutlinedIcon className="h-6 w-6" />
          )}
        </span>

        {/* Breadcrumb here */}
        <div className="flex flex-col px-3 ">
          <Breadcrumbs aria-label="breadcrumb" className="px-1" style={{ fontSize: '12px' }}>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate('/dashboard')}
              style={{ cursor: 'pointer' }}
            >
              Home
            </Link>
            {pathSegments.map((segment, index) => {
              const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
              return (
                <Link
                  key={index}
                  underline="hover"
                  color="inherit"
                  onClick={() => navigate(url)}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  {segment}
                </Link>
              );
            })}
          </Breadcrumbs>
          <div className="clock flex items-center">
            <AccessTimeOutlinedIcon fontSize="small" />
            <Clock />
          </div>
        </div>
        {/* Breadcrumb here */}
      </div>
      <div className="icon flex items-center">
        <HomeOutlinedIcon
          className="h-6 w-6"
          onClick={() => navigate('/dashboard')}
        />
        <div className="relative group">
          <AppsOutlinedIcon className="h-6 w-6" alt="App icon" onClick={openModal} />
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 w-max text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Employee Check In
          </div>
        </div>

        {/* <div className="notification relative cursor-pointer">
          <NotificationsOutlinedIcon className="h-6 w-6" alt="Notifications icon" />
          <span className="absolute top-0 right-0 text-xs text-white bg-red-600 rounded-full px-1">
            3
          </span>
        </div> */}

        <div className="user flex items-center gap-4">
          <NavUserButton />
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} header="Employee Checkin" size="medium">
        <EmployeeCheckIn />
      </Modal>
    </div>
  );
}

NavBar.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
  setIsSidebarOpen: PropTypes.func.isRequired,
  toggleTheme: PropTypes.func.isRequired, // Add toggleTheme prop
  mode: PropTypes.string.isRequired, // Add mode prop
};

export default NavBar;
